//import Home from './../views/Home'
import DiezK from "../views/DiezK";
import Resumen from "../views/Resumen";
import Listado from "../views/Listado";
import Completada from "../views/Completada";
import Fallida from "../views/Fallida";
import Equipos from "../views/Equipos";
import Modificar from "../views/Modificar";
import Infantil from "../views/Infantil";
import SieteK from "../views/SieteK";
import Cerrado from "../views/Cerrado";
import Panel from "../views/panel/Panel";
import Login from "../views/panel/Login";
import Editar from "../views/panel/Editar";
import EditaInfantil from "../views/panel/EditaInfantil";
import Invitar from "../views/panel/Invitar";

export const routes = [
    { path: '/', component: DiezK, name:'home' },
    { path: '/roscon', component: DiezK, name:'roscon' },
    { path: '/roscon/listado', component: Listado, name:'listado', props: { carrera: 1 } },
    { path: '/infantil/listado', component: Listado, name:'listadoInfantil', props: { carrera: 3 } },
    { path: '/corta/listado', component: Listado, name:'listadoCorta', props: { carrera: 2 } },
    { path: '/resumen', component: Resumen, name:'resumen', props: true },
    { path: '/completada', component: Completada, name:'completada', props: true },
    { path: '/modificar', component: Modificar , name:'modificar' },
    { path: '/fallida', component: Fallida , name:'fallida' },
    { path: '/roscon/equipos', component: Equipos , name:'equipos', props: { carrera: 1 }},
    { path: '/corta/equipos', component: Equipos , name:'equiposCorta', props: { carrera: 2 }},
    { path: '/infantil', component: Infantil , name:'infantil' },
    { path: '/corta', component: SieteK , name:'corta' },
    { path: '/cerrado', component: Cerrado, name:'cerrado', props: true},
    { path: '/panel', component: Panel, name:'panel' },
    { path: '/login', component: Login, name:'login' },
    { path: '/panel/editar', component: Editar, name:'editar', props: true },
    { path: '/panel/editaInfantil', component: EditaInfantil, name:'editaInfantil', props: true },
    { path: '/panel/invitar', component: Invitar, name:'invitar' },
    { path: "*", component: DiezK }
]